import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import logo from '../../images/logo/log112.png';
import logo2 from '../../images/logo/log112.png';

import MobileMenu from '../MobileMenu/MobileMenu';

const Header3 = () => {
    const [mobailActive, setMobailState] = useState(false);
    const [isSticky, setSticky] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMobailState(false);
    };

    useEffect(() => {
        const handleScroll = () => {
            setSticky(window.scrollY > 80);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            id="xb-header-area"
            className="header-area header-style-two header-style-six header-transparent"
        >
            <div className={`xb-header stricky ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="header__wrap ul_li_between">

                        {/* Logo */}
                        <div className="header-logo logo-pill">
                            <Link onClick={ClickHandler} to="/">
                                <img src={logo} alt="ARO Events Logo" />
                                  <img src={logo} alt="ARO Events Logo" />
                            </Link>
                        </div>

                        {/* Right Area */}
                        <div className="header-right ul_li">
                            <div className="main-menu__wrap ul_li navbar navbar-expand-xl">

                                {/* Desktop Menu */}
                                <nav className="main-menu collapse navbar-collapse">
                                    <ul>
                                        <li>
                                            <Link onClick={ClickHandler} to="/">
                                                <span>Home</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/about">
                                                <span>About</span>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/contact">
                                                <span>Contact Us</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>

                                {/* Mobile Menu Wrapper */}
                                <div className="xb-header-wrap">
                                    <div className={`xb-header-menu ${mobailActive ? 'active' : ''}`}>
                                        <div className="xb-header-menu-scroll lenis lenis-smooth">

                                            <div
                                                className="xb-menu-close xb-hide-xl xb-close"
                                                onClick={() => setMobailState(false)}
                                            ></div>

                                            <div className="xb-logo-mobile xb-hide-xl">
                                                <Link onClick={ClickHandler} to="/">
                                                    <img src={logo2} alt="ARO Events Mobile Logo" style={{height: '30px', width: '170px'}} />
                                                </Link>
                                            </div>

                                            <nav className="xb-header-nav">
                                                <MobileMenu />
                                            </nav>
                                        </div>
                                    </div>
                                    <div className="xb-header-menu-backdrop"></div>
                                </div>
                            </div>

                            {/* Mobile Hamburger */}
                            <div className="header-bar-mobile side-menu d-xl-none">
                                <button
                                    className="xb-nav-mobile"
                                    onClick={() => setMobailState(!mobailActive)}
                                >
                                    <i className="far fa-bars"></i>
                                </button>
                            </div>

                       

                        </div>
                        {/* End Right */}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header3;
